import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
import Slider from 'react-slick';
 
import axios from 'axios';  
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { base_url} from '../common/Constants';

 
class ProductsSlider extends React.Component{

    constructor(props){
        super(props);
 
        this.state = {
            loading : 0 
          };
    }
 
    componentDidMount() {
        const script = document.createElement("script");
        script.src   = base_url+"assets/js/loadSlider.js";  
        script.async = true;
        document.body.appendChild(script);

        script.onload = () => {
        if (window.productLeftSlider && this.state.loading == 0 ) {
        window.productLeftSlider();
        this.setState({loading:1})
        }
        };
      }

    render()
    { 
        
    return (
 
           <div class="ul-product-details-img-slider swiper">
              <div class="swiper-wrapper">
                  {this.props.image.map((item, index) => (
                  <div class="swiper-slide"><img src={item} alt={this.props.title} /></div>
                    ))}
                </div>

              <div class="ul-product-details-img-slider-nav" id="ul-product-details-img-slider-nav">
                  <button class="prev"><i class="flaticon-left-arrow"></i></button>
                  <button class="next"><i class="flaticon-arrow-point-to-right"></i></button>
              </div>
          </div>
         
    );
}

}

export default ProductsSlider;